<template>
  <v-container>
    <v-row>
      <v-col lg="5" offset-lg="1" cols="12">
        <Form></Form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Form from "./components/Form";
export default {
  name: "Registration",
  components: { Form }
};
</script>

<style scoped></style>
